export default defineNuxtRouteMiddleware(async () => {
	const nuxtApp = useNuxtApp()
	const userStore = useUserStore()
	const isLogged = useCookie('is_logged')

	if (isLogged.value) {
		if (!userStore.state.user) {
			try {
				await userStore.fetchUser()
			} catch {
				await nuxtApp.runWithContext(async () => {
					await userStore.logout()
				})
			}
		}
	} else if (userStore.state.user) {
		await nuxtApp.runWithContext(async () => {
			await userStore.logout()
		})
	}
})
